import { useSelector } from 'react-redux';

import { RootState } from '@share/utils';

/**
 * Whether the logged member can cash out right now: eligible under their wallet rules and with
 * something to cash out. Resolved once per wallet load (loadCanCashOut in the login store), so it is
 * ready before any menu opens. Entry points to the cash-out only appear when it is true; a link that
 * always leads to "not available" reads as a bug.
 */
export function useCanCashOut(): boolean {
  return useSelector((state: RootState) => state.loginStore.canCashOut);
}
